/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [{
        url: "/home",
        name: "Agendamiento",
        slug: "home",
        icon: "AirplayIcon",
    },
    {
        url: "/usuarios",
        name: "Usuarios",
        slug: "usuarios",
        icon: "UsersIcon",
    },
    {
        url: "/asesores",
        name: "Asesores",
        slug: "asesores",
        icon: "UserMinusIcon",
    }
]